import { ChromeTab } from "types/chromeTab";
import { ChromeWindow } from "types/chromeWindow";

export default async function getWindowTab(): Promise<ChromeTab> {
  const chromeApi =
    // @ts-ignore
    window.chrome && window.chrome.tabs && window.chrome.windows
      // @ts-ignore
      ? window.chrome
      : undefined;
  if (chromeApi) {
    // @ts-ignore
    const activeWindow: ChromeWindow = await chromeApi.windows.getCurrent(),
      activeTabs: ChromeTab[] = await chromeApi.tabs.query({
        active: true,
        currentWindow: true,
      });

    //One active tab per potentially many windows
    if (activeWindow.type === 'normal') {
    for (const tab of activeTabs) {
      if (tab.windowId === activeWindow.id) {
        return tab;
      }
    }
  }
    else {
      const activeTab = await findActiveTabinAllWindows();
      if (activeTab) {
        return activeTab;
      } else {
        console.log('No active tab found.');
      }
    }
  }
  return {
    active: true,
    id: -1, //TAB_ID_NONE
    url: window.location ? window.location.href : "Unknown url",
  };
}

function getAllWindows(): Promise<any> {
  //get all windows
  return new Promise((resolve, reject) => {
    chrome.windows.getAll({ populate: true }, (windows) => {
      if (chrome.runtime.lastError) {
        reject(new Error(chrome.runtime.lastError.message));
      } else {
        resolve(windows);
      }
    });
  });
}

async function findActiveTabinAllWindows(): Promise<any> {
  try {
    // get all thw windows synchronously
    const windows = await getAllWindows();

    let activeTab: any = null;
    //get the pop up window id from local storege. This id is stored when pop up is creating
    const extensionWindowId = localStorage.getItem("PopUpWindowId");

    // loop through all windows and find the active tab in a normal window
    for (const window of windows) {
      if (window.id?.toString() !== extensionWindowId && window.type === 'normal') {
        activeTab = window.tabs.find((tab: any) => tab.active) || null;
        if (activeTab) {
          return activeTab; // return the found active tab
        }
      }
    }

    // if no active tab is found, log a message
    console.log('No active tab found in any other window.');
    return null;
  } catch (error) {
    console.error('Error fetching windows:', error);
    return null; // return null in case of an error
  }
}
